export default __webpack_public_path__ + "c1519386dc1bed4f93e694fd17b3ca13.png";